import { api } from "./client";
import type { Tenant, TenantCreate, TenantStats, TenantUpdate } from "@/types";

const base = "/admin/tenants";

export const tenantsApi = {
  async list(): Promise<Tenant[]> {
    const { data } = await api.get<Tenant[]>(base);
    return data;
  },
  async get(id: string): Promise<Tenant> {
    const { data } = await api.get<Tenant>(`${base}/${id}`);
    return data;
  },
  async create(payload: TenantCreate): Promise<Tenant> {
    const { data } = await api.post<Tenant>(base, payload);
    return data;
  },
  async update(id: string, payload: TenantUpdate): Promise<Tenant> {
    const { data } = await api.patch<Tenant>(`${base}/${id}`, payload);
    return data;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`${base}/${id}`);
  },
  /** Indicadores agregados de todos os ativos do tenant — pra Dashboard. */
  async stats(id: string, q?: { from?: string; to?: string; site_id?: string }): Promise<TenantStats> {
    const { data } = await api.get<TenantStats>(`/tenants/${id}/stats`, { params: q });
    return data;
  },
};
